import { createAction, handleActions } from 'redux-actions';
import { omit } from 'lodash';
import { database } from '../../firebase';

const charitiesRef = database.ref('/charities');

export enum ACTION_TYPES {
  INSERT_CHARITIES = '@DONACO/INSERT_CHARITIES',
  DELETE_CHARITY = '@DONACO/DELETE_CHARITY',
  CHARITY_DELETED = '@DONACO/CHARITY_DELETED',
  CURRENTLY_EDITING_CHARITY = '@DONACO/CURRENTLY_EDITING_CHARITY',
  SAVING_CHARITY = '@DONACO/SAVING_CHARITY',
  SAVED_CHARITY = '@DONACO/SAVED_CHARITY',
  CLEAR_SAVED_CHARITY = '@DONACO/CLEAR_SAVED_CHARITY',
  CLEAR_CURRENTLY_EDITING_CHARITY = '@DONACO/CLEAR_CURRENTLY_EDITING_CHARITY',
  CURRENTLY_EDITING_CHARITY_IMAGE = '@DONACO/CURRENTLY_EDITING_CHARITY_IMAGE',
  CLEAR_CURRENTLY_EDITING_CHARITY_IMAGE = '@DONACO/CLEAR_CURRENTLY_EDITING_CHARITY_IMAGE',
}

const currentlyEditingCharity = {
  logoImgName: '',
  charityUrl: '',
  logoImgUrl: '',
  mobileLogoImgName: '',
  mobileLogoImgUrl: ''
};
const defaultState = {
  all: [],
  currentlyEditingCharity,
};
export const charitiesReducer = handleActions({
  [ACTION_TYPES.INSERT_CHARITIES]: (state, action) => {
    return {
      ...state,
      all: action.payload
    };
  },
  [ACTION_TYPES.CHARITY_DELETED]: (state: any, action: any) => {
    const all = omit(state.all, [ action.payload ]);
    return {
      ...state,
      all
    };
  },
  [ACTION_TYPES.CURRENTLY_EDITING_CHARITY]: (state, action) => {
    const currentlyEditingCharity = action.payload;
    return {
      ...state,
      currentlyEditingCharity
    };
  },
  [ACTION_TYPES.SAVING_CHARITY]: (state, action) => {
    return {
      ...state,
      saving: true
    };
  },
  [ACTION_TYPES.SAVED_CHARITY]: (state, action) => {
    return {
      ...state,
      saving: false,
      saved: true
    };
  },
  [ACTION_TYPES.CLEAR_CURRENTLY_EDITING_CHARITY]: (state, action) => {
    return {
      ...state,
      currentlyEditingCharity,
    };
  },
  [ACTION_TYPES.CLEAR_SAVED_CHARITY]: (state, action) => {
    return {
      ...state,
      saved: false
    };
  },
  [ACTION_TYPES.CURRENTLY_EDITING_CHARITY_IMAGE]: (state, action) => {
    const imageDetails = action.payload;
    return {
      ...state,
      currentlyEditingCharity: {
        ...state.currentlyEditingCharity,
        ...imageDetails
      }
    };
  },
  [ACTION_TYPES.CLEAR_CURRENTLY_EDITING_CHARITY_IMAGE]: (state, action) => {
    return {
      ...state,
      currentlyEditingCharity: {
        ...state.currentlyEditingCharity,
        logoImgUrl: '',
        mobileLogoImgUrl: '',
        logoImgName: '',
        mobileLogoImgName: ''
      }
    };
  }
}, defaultState);

const insertCharitiesAction = createAction(ACTION_TYPES.INSERT_CHARITIES, (payload) => payload);
const deleteCharityAction = createAction(ACTION_TYPES.DELETE_CHARITY, (payload) => payload);
const charityDeletedAction = createAction(ACTION_TYPES.CHARITY_DELETED, (payload) => payload);
export const charityCurrentlyEditingAction = createAction(ACTION_TYPES.CURRENTLY_EDITING_CHARITY, (payload) => payload);
export const charityCurrentlyEditingImageAction = createAction(ACTION_TYPES.CURRENTLY_EDITING_CHARITY_IMAGE, (payload) => payload);
export const clearCurrentlyEditingCharityAction = createAction(ACTION_TYPES.CLEAR_CURRENTLY_EDITING_CHARITY);
export const savingCharityAction = createAction(ACTION_TYPES.SAVING_CHARITY);
export const savedCharityAction = createAction(ACTION_TYPES.SAVED_CHARITY);
export const clearSavedCharityAction = createAction(ACTION_TYPES.CLEAR_SAVED_CHARITY);
export const removeImageForCurrentlyEditingCharity = createAction(ACTION_TYPES.CLEAR_CURRENTLY_EDITING_CHARITY_IMAGE);

export const deleteCharity = (uid) => {
  return (dispatch) => {
    dispatch(deleteCharityAction(uid));
    dispatch(deleteFromFirebaseCharity(uid));
  };
};

export const deleteFromFirebaseCharity = (uid) => {
  return (dispatch) => {
    database.ref(`/charities/${uid}`)
      .remove()
      .then(() => {
        dispatch(charityDeletedAction(uid));
      });
  };
};

export const extractCharityFormData = (data) => {
  const {
    name,
    charityId,
    description,
    stripeAccount,
    email,
    facebook,
    twitter,
    charityUrl,
    logoImgName,
    logoImgUrl,
    mobileLogoImgName,
    mobileLogoImgUrl,
    userName,
    role,
    phoneNumber,
    timestamp,
    paypalAccount,
} = data;

  return {
    name,
    charityId: charityId || '',
    description: description || '',
    email: email || '',
    facebook: facebook || '',
    twitter: twitter || '',
    charityUrl: charityUrl || '',
    logoImgName: logoImgName || '',
    logoImgUrl: logoImgUrl || '',
    mobileLogoImgName: mobileLogoImgName || '',
    mobileLogoImgUrl: mobileLogoImgUrl || '',
    imageUrl: logoImgUrl || '',
    stripeAccount: stripeAccount || '',
    userName: userName || '',
    role: role || '',
    phoneNumber: phoneNumber || '',
    timestamp: timestamp || '',
    paypalAccount: paypalAccount || '',
  }
};

export const startListeningForCharities = () => {
  return (dispatch) => {
    charitiesRef.on('value', (snapshot) => {
      const charities = snapshot.val();
      dispatch(insertCharitiesAction(charities));
    });
  };
};
